import React from "react";
import { MdEmail } from "react-icons/md";
import { BsFillTelephoneFill } from "react-icons/bs";
import { RiAdminFill } from "react-icons/ri";
import ButtonComponent from "../../components/Button";
import InputComponent from "../../components/Input";
import SelectDropdown from "../../components/SelectDropdown";
import { useFormik } from "formik";
import * as Yup from "yup";

const AddMemberPage = () => {
  const validationSchema = Yup.object({
    phoneNumber: Yup.string()
      .required("Phone number is required")
      .matches(/^[0-9]+$/, "Phone number must be digits only"),
    password: Yup.string()
      .required("Password is required")
      .min(6, "Password must be at least 6 characters"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    identity: Yup.string().required("Identity ID is required"),
    role: Yup.string().required("Role is required"),
  });

  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
      password: "",
      email: "",
      identity: "",
      role: "admin",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
   
    },
  });

  return (
    <div className="p-[25px] rounded-md border-[solid] border bg-white">
      <h3 className="font-medium bg-red">Add New Member</h3>
      <p className="text-sm text-[#595858] mt-2">
        In publishing and graphic design, Lorem ipsum is a placeholder text
        commonly used to demonstrate the visual form of a document or a
        typeface without relying on meaningful content.
      </p>

      {/* Form starts here */}
      <form className="mt-5" onSubmit={formik.handleSubmit}>
        <div className="flex space-x-4">
          {/* Phone Number Field */}
          <div className="flex-1">
            <label
              htmlFor="phoneNumber"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Phone Number
            </label>
            <InputComponent
              icon={<BsFillTelephoneFill />}
              type="text"
              name="phoneNumber"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.phoneNumber && formik.errors.phoneNumber}
              placeholder="Enter phone number"
            />
            {formik.touched.phoneNumber && formik.errors.phoneNumber && (
              <p className="text-red-500 text-sm">{formik.errors.phoneNumber}</p>
            )}
          </div>

          {/* Password Field */}
          <div className="flex-1">
            <label
              htmlFor="password"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Password
            </label>
            <InputComponent
              type="password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter password"
            />
            {formik.touched.password && formik.errors.password && (
              <p className="text-red-500 text-sm">{formik.errors.password}</p>
            )}
          </div>
        </div>

        <div className="flex space-x-4 mt-4">
          {/* Email Field */}
          <div className="flex-1">
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Email
            </label>
            <InputComponent
              icon={<MdEmail />}
              type="email"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter email"
            />
            {formik.touched.email && formik.errors.email && (
              <p className="text-red-500 text-sm">{formik.errors.email}</p>
            )}
          </div>

          {/* Identity ID Field */}
          <div className="flex-1">
            <label
              htmlFor="identity"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Identity Id
            </label>
            <InputComponent
              type="text"
              name="identity"
              value={formik.values.identity}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              placeholder="Enter Identity ID"
            />
            {formik.touched.identity && formik.errors.identity && (
              <p className="text-red-500 text-sm">{formik.errors.identity}</p>
            )}
          </div>
        </div>

        {/* Role Dropdown */}
        <div className="mt-4">
          <label
            htmlFor="role"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Select Role
          </label>
          <SelectDropdown
            name="role"
            icon={<RiAdminFill />}
            value={formik.values.role}
            options={[
              { value: "admin", label: "Admin" },
              { value: "driver", label: "Driver" },
              { value: "vendor", label: "Vendor" },
            ]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.role && formik.errors.role && (
            <p className="text-red-500 text-sm">{formik.errors.role}</p>
          )}
        </div>

        {/* Submit Button */}
        <div className="mt-5 text-right rounded">
          <ButtonComponent text="Add New Role" type="submit" />
        </div>
      </form>
    </div>
  );
};

export default AddMemberPage;
